module.exports = __webpack_public_path__ + "img/logo2.eb6352a8.jpg";